import { Typography } from "antd";
import styled from "styled-components";

export const StyledWPEmptyMarketGif = styled.img`
    width: 80%;
    object-fit: contain;
`;

export const StyledEmptyText = styled(Typography)`
    text-align: center;
`;
